import {BasePageLayout} from "../components/grouping/BasePageLayout";
import {Section} from "../components/grouping/Section";
import {Button, Col, Row} from "react-bootstrap";
import {useEffect, useRef, useState} from "react";
import {minioBaseUrl} from "../data/defaultConfig";
import Collapse from "react-bootstrap/Collapse";
import 'react-pdf/dist/Page/TextLayer.css';
import 'react-pdf/dist/Page/AnnotationLayer.css';
import "@cyntler/react-doc-viewer/dist/index.css";
import {pdfjs} from 'react-pdf';
import 'react-pdf/dist/Page/AnnotationLayer.css';
import {PdfViewerCustom} from "../components/PdfViewerCustom";
import {useMagazineHeadingHeadings} from "../api/magazineheadingsapi";
import {FaCloudDownloadAlt} from "react-icons/fa";
import {FaChevronCircleDown} from "react-icons/fa";
import {FaChevronCircleUp} from "react-icons/fa";

export function MagazinePage(props) {
    const {magazineHeadings} = useMagazineHeadingHeadings();
    pdfjs.GlobalWorkerOptions.workerSrc = new URL(
        'pdfjs-dist/build/pdf.worker.min.mjs',
        import.meta.url,
    ).toString();

    return <BasePageLayout title={"Tijdschrift"}>
        <div>
            {magazineHeadings ? magazineHeadings.sort((mh1, mh2) => new Date(mh2.date).getTime() - new Date(mh1.date).getTime()).map((mh, index) =>
                    <MagazineHeading defaultOpen={index === 0} magazineHeading={mh}/>) :
                ""}
        </div>

    </BasePageLayout>
}

function MagazineHeading(props) {
    const {magazineHeading, defaultOpen} = props;
    const [open, setOpen] = useState(!!defaultOpen);
    return <Section>
        <Button
            onClick={() => setOpen(!open)}
            className={"btn-light mb-2 shadow border-black"}
            aria-controls="example-collapse-text"
            aria-expanded={open}
        >
            <Section>
                <Col className={"fs-5 ms-5 text-center"}>
                    {magazineHeading?.title}
                </Col>
                <Col xs={"auto"} className={"text-end"}>
                    {open ? <FaChevronCircleUp/> : <FaChevronCircleDown/>}
                </Col>
            </Section>
        </Button>
        <Collapse in={open}>
            <div id="example-collapse-text">
                {magazineHeading.timeMagazines ? magazineHeading.timeMagazines.sort((m1, m2) => new Date(m2.date).getTime() - new Date(m1.date).getTime()).map(m =>
                        <Magazine key={m.id} magazine={m}/>) :
                    "Nog geen tijdschriften voor te bekijken. Kom later nog eens terug."
                }
            </div>
        </Collapse>
    </Section>
}

function Magazine(props) {
    const {magazine, parentWidth} = props;
    const [open, setOpen] = useState(false);
    const url = magazine?.file?.url;
    return <Section>
        <Row className={"g-0 justify-content-center"}>
            <Col xs={6} md={4} className={"text-end"}>
                <Button
                    onClick={() => setOpen(!open)}
                    className={"btn-light border-black mb-2 w-100"}
                    aria-controls="example-collapse-text"
                    aria-expanded={open}
                >
                    <Section>
                        <Col xs={12}>
                            {magazine?.title}
                        </Col>
                    </Section>
                </Button>
            </Col>
            <Col xs={"auto"}>
                <Button
                    href={minioBaseUrl + url}
                    target={"_blank"}
                    className={"btn-light ms-1 border-black mb-2 w-100"}
                    aria-controls="example-collapse-text"
                    aria-expanded={open}
                >
                    <Section>
                        <Col>
                            <FaCloudDownloadAlt/>
                        </Col>
                    </Section>
                </Button>
            </Col>
        </Row>
        <Collapse in={open}>
            <div id="example-collapse-text">
                {url ?
                    <Section>
                        <Col/>
                        <Col>
                            <PdfViewerCustom url={url} parentWidth={parentWidth}/>
                        </Col>
                        <Col/>
                    </Section>
                    : "Nog geen magazine toegevoegd. Kom later nog eens terug."}
            </div>
        </Collapse>
    </Section>

}




